<div class="tw-flex tw-flex-full">
  @if (true) {
    <router-outlet></router-outlet>
  }
</div>
